<div class="coupon">
  <span class="coupon-title">{{ 'cart.coupon.title' | translate }}</span>

  @if (!appliedCouponCode) {
    <div class="coupon-input-container">
      <input
        type="text"
        [(ngModel)]="couponCode"
        [placeholder]="'cart.coupon.placeholder' | translate"
        [disabled]="isLoading"
        class="coupon-input"
        (keyup.enter)="applyCoupon()"
      />
      <cx-button class="coupon-btn" (click)="applyCoupon()" [disabled]="isLoading || !couponCode.trim()">
        @if (isLoading) {
          <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
        }
        {{ 'cart.coupon.apply' | translate }}
      </cx-button>
    </div>

    @if (errorMessage) {
      <span class="coupon-error">{{ errorMessage | translate }}</span>
    }
  } @else {
    <div class="coupon-applied">
      <div class="coupon-applied-chip">
        <span class="material-symbols-outlined coupon-applied-icon">confirmation_number</span>
        <div class="coupon-applied-info">
          <span class="coupon-applied-code">{{ appliedCouponCode }}</span>
          @if (appliedCouponMessage) {
            <span class="coupon-applied-message">{{ appliedCouponMessage }}</span>
          }
        </div>
        <button
          class="coupon-remove-btn"
          (click)="removeCoupon()"
          type="button"
          [disabled]="isLoading"
          [title]="'cart.coupon.remove' | translate"
        >
          @if (isLoading) {
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          } @else {
            <span class="material-symbols-outlined">close</span>
          }
        </button>
      </div>
    </div>
  }
</div>
